import cImg1 from '../images/blog/close-up-notebook-used-by-employees-developing-ai-systems-tech-startup.jpg'
import cImg2 from '../images/blog/report2.jpg'
import cImg3 from '../images/blog/report3.jpg'





const caseStudies = [
    { id: 1, category: "cat1", img: cImg1, title: "2025 Unit 42 Global Incident Response Report: Social Engineering Edition", slug: "https://unit42.paloaltonetworks.com/2025-unit-42-global-incident-response-report-social-engineering-edition/" },
    { id: 2, category: "cat1", img: cImg2, title: "CrowdStrike 2025 Global Threat Report", slug: "https://www.crowdstrike.com/en-us/global-threat-report/" },
    { id: 3, category: "cat1", img: cImg3, title: "Fortinet 2025 Global Threat Landscape..", slug: "https://www.fortinet.com/uk/resources/reports/threat-landscape-report" },
    // { id: 4, category: "cat1", img: cImg4, title: "Design system & UI kit..", slug: "Design" },
    // { id: 5, category: "cat1", img: cImg5, title: "Offline SEO marketing..", slug: "Development" },
    // { id: 6, category: "cat1", img: cImg6, title: "IT security enhancement..", slug: "Support" },
   ];
export default caseStudies;